
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { isMobile, isTablet } from "mobile-device-detect";
import { Settings } from "../constant";
import PlusCircleIcon from "@/assets/icons/PlusCircle.vue";
import MinusCircleIcon from "@/assets/icons/MinusCircle.vue";
import PrinterIcon from "@/assets/icons/Printer.vue";
@Component({
  components: {
    PlusCircleIcon,
    MinusCircleIcon,
    PrinterIcon
  },
})
export default class PlatmapToolBar extends Vue {
  private toolbarTopPosition = 0;
  private autoZoom = false;
  @Prop() private zoomInDisabled: boolean;
  @Prop() private zoomOutDisabled: boolean;
  @Prop() private headerOpen!: boolean;
  @Prop() private isKioskMode!: boolean;
  @Prop() private toolbar!: boolean;

  @Emit("zoomIn") zoomIn() {}

  @Emit("zoomOut") zoomOut() {}

  @Emit("handlePrintClick") handlePrintClick() {
    this.calculateContactInfoTopPosition();
  }

  @Emit("calculateContactInfoTopPosition") calculateContactInfoTopPosition() {}

  @Emit("autoFit") autoFit() {
    this.autoZoom = !this.autoZoom;
  }

  @Emit("toggleToolbar") toggleToolbar() {}

  @Watch("zoomInDisabled") disableZoomIn() {
    let zoomIn = document.querySelector(".zoom_in") as HTMLDivElement;
    if (this.zoomInDisabled) {
      zoomIn.style.pointerEvents = "none";
      zoomIn.style.opacity = "0.5";
    } else {
      zoomIn.style.pointerEvents = "auto";
      zoomIn.style.opacity = "1";
    }
  }
  @Watch("zoomOutDisabled") disableZoomOut() {
    let zoomOut = document.querySelector(".zoom_out") as HTMLDivElement;
    if (this.zoomOutDisabled) {
      zoomOut.style.pointerEvents = "none";
      zoomOut.style.opacity = "0.5";
    } else {
      zoomOut.style.pointerEvents = "auto";
      zoomOut.style.opacity = "1";
    }
  }

  @Watch("headerOpen")
  onToggleHeader(val: string, oldVal: string) {
    if (val !== oldVal) {
      this.calculateToolbarTopPosition();
    }
  }

  mounted() {
    this.calculateToolbarTopPosition();
  }

  calculateToolbarTopPosition() {
    const outerHeight =
      isMobile && !isTablet
        ? Settings.TOP_OUTER_HEIGHT_MOBILE
        : Settings.TOP_OUTER_HEIGHT_TABLET;
    const header = document.getElementById("header") as HTMLElement;
    this.toolbarTopPosition =
      (header && header.clientHeight
        ? header.clientHeight
        : Settings.TOP_OUTER_HEIGHT_TABLET) + outerHeight;
  }
}
